import { createAction } from '@reduxjs/toolkit'

/* Action Creators */
export const DownloadActiveMetersAction = createAction('reports/downloadActiveMetersAction')
